module.exports = __webpack_public_path__ + "img/insurita-value-one.e259bb03.png";